<template>
    <div class="col-lg-10 col-12 position-relative cancelarReserva mb-5">
        <b-card-group deck>
            <b-card header-tag="header" footer-tag="footer">
                <div class="row">
                    <div class="col-7 col-lg-10 mb-3">
                        <p class="estancia mb-0">{{$t('language.posadasCorporate.inforPersonal.infoPersonal')}}</p>
                        <span class="notas">{{$t('language.posadasCorporate.inforPersonal.ultimoIngreso')}}: {{ currentDate }}</span>
                    </div>
                    <div class="col-5 col-lg-2">
                        <router-link to="/administracion-de-usuarios/informacion-personal">
                            <p class="enlace text-right">{{$t('language.posadasCorporate.inforPersonal.editar')}}</p>
                        </router-link>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-12 col-lg-3">
                        <div class="row">
                            <p class="col-10 mb-0"><b>{{$t('language.posadasCorporate.inforPersonal.nomUsuario')}}</b>
                                <span class="">{{userName}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3">
                        <div class="row">
                            <p class="col-10 mb-0"><b>{{$t('language.posadasCorporate.inforPersonal.nombre')}}</b>
                                <span class="">{{ name }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3">
                        <div class="row">
                            <p class="col-10 mb-0"><b>{{$t('language.posadasCorporate.inforPersonal.apellido')}}</b>
                                <span class="">{{ surname }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                
            </b-card>
        </b-card-group>
    </div>
</template>

<script>
    import * as GlobalFunctions from '../../../utils/GlobalFunctions';
    import SecureLS from 'secure-ls';
    import axios from 'axios';

    export default {
        name: 'InformacionPersonal',
        data() {
            return {
                userName: "",
                name: "",
                surname: "",
                ls: new SecureLS({ encodingType: "aes" }),
                currentDate: "",

           }
       },
       created() {
        if (!GlobalFunctions.validIfGenericUser()) {
            this.userName = this.ls.get('Profile').data.username
            this.name = this.ls.get('Profile').data.name
            this.surname = this.ls.get('Profile').data.surname 
            this.getUserDetailSesssion(this.ls.get('Profile').data.username)
        }
       },
       methods: {
           getUserDetailSesssion(userId) {
            axios.post( process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_CONDU,  {

                    "userId": userId,

            },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }).then(response => {
              this.currentDate = response.data.response.lastLogin
              this.currentDate = this.currentDate.replace(/-/g, '/') 
              
           
        }).catch(error => {
                })
      },
           
       }
    }
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/config.scss';
.contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
}
.enlace {
    font-size: 14px;
    font-weight: 500;
    color: $colorBase2;
}
.contacto {
    width: 100%;
    margin-top: 57px;
    padding-top: 32px;
    .card-body {
        min-height: 181px;
        .card-title {
            font-size: $font-size-large;
        }
    }
    .estancia {
        font-size: $font-size-biglarge;
        font-weight: bold;
    }
}
</style>